import { severityLevelFromString } from '@sentry/core';
/**
 * Turns a browser log line into the breadcrumb that replaces it on production.
 *
 * `severityLevelFromString` is the SDK's own mapper rather than a hand-written table: it is what the
 * native console breadcrumb handler uses (`warn` → `warning`, anything it does not know — including
 * `trace` — → `log`), so our breadcrumbs sort and filter in the Sentry UI exactly like the built-in
 * ones do.
 *
 * `obj` arrives already reduced by `createTelemetryTransport`, so this never re-filters it.
 * @__NO_SIDE_EFFECTS__
 */
export function toLogBreadcrumb(logger, level, message, obj) {
    return {
        category: 'log',
        type: 'debug',
        level: severityLevelFromString(level),
        message: logger ? `[${logger}] ${message}` : message,
        data: obj ?? undefined,
    };
}
//# sourceMappingURL=toLogBreadcrumb.js.map